import React from "react";
import { Col, Row } from "reactstrap";
import {
  faBuilding,
  faChartLine,
  faCog,
  faLifeRing,
  faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
import HubLinkCard from "../common/HubLinkCard";
import PageHeader from "../common/PageHeader";

const SECTIONS = [
  {
    key: "condominiums",
    to: "/root/condominiums",
    icon: faBuilding,
    color: "primary",
    title: "Condominios",
    description: "Los condominios registrados, sus administradores y propiedades.",
  },
  {
    key: "indicators",
    to: "/root/indicators",
    icon: faChartLine,
    color: "info",
    title: "Indicadores",
    description: "Adopción de Homelan en los condominios y actividad por módulo.",
  },
  {
    key: "support",
    to: "/root/support",
    icon: faLifeRing,
    color: "warning",
    title: "Soporte",
    description: "Tickets y solicitudes de los usuarios de Homelan.",
  },
  {
    key: "config",
    to: "/root/config",
    icon: faCog,
    color: "secondary",
    title: "Configuración",
    description: "Precios por propiedad y parámetros generales del sistema.",
  },
  {
    key: "lead",
    to: "/root/lead",
    icon: faUserPlus,
    color: "success",
    title: "Leads",
    description: "Prospectos interesados en usar Homelan en su condominio.",
  },
];

const Root = () => (
  <>
    <PageHeader
      title="Gestión del sistema Homelan"
      titleTag="h2"
      description="Elige el módulo que quieres gestionar."
      className="mb-3"
      col={{ lg: 9 }}
    />
    <Row>
      {SECTIONS.map(({ key, ...section }) => (
        <Col key={key} sm={6} xl={4} className="mb-3">
          <HubLinkCard {...section} />
        </Col>
      ))}
    </Row>
  </>
);

export default Root;
